import React, { useState } from 'react';
import axios from 'axios';

const MODULE_NAME = "_44_user_register";

const _44_user_register = (props) => {
    const [fname, setFname] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [timezoneVal, setTimezoneVal] = useState('est'); // default is "est"
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const [tooltip, setTooltip] = useState('');
    const [acceptedTerms, setAcceptedTerms] = useState(false);

    const screen = props.screen;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setLoading(true);
        if (!acceptedTerms) {
            setError('Please accept the Terms and Conditions to register.');
            setLoading(false);
            return;
        }
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/register`, {
                fname,
                email,
                password,
                confirm_password: confirmPassword,
                timezone: timezoneVal
            });

            if (res.data.success) {
                setTooltip(res.data.tooltip || '');

                // Attempt auto-login using returned user info, or fallback to calling /api/login
                try {
                    let userId = res.data.user_id ?? res.data.userId ?? res.data.user?.id;
                    let userType = res.data.user_type ?? res.data.userType ?? res.data.user?.type;

                    if (!userId) {
                        const loginRes = await axios.post(`${process.env.REACT_APP_API_URL}/api/login`, { email, password });
                        if (loginRes.data?.success) {
                            userId = loginRes.data.user_id ?? loginRes.data.userId ?? loginRes.data.user?.id;
                            userType = loginRes.data.user_type ?? loginRes.data.userType ?? res.data.user?.type;
                        }
                    }

                    if (userId) {
                        sessionStorage.setItem("first_login_after_register", "true");
                        if (typeof props.onLoginSuccess === "function") {
                            props.onLoginSuccess(userId, userType || "standard");
                        } else {
                            sessionStorage.setItem("user_id", userId);
                            if (userType) sessionStorage.setItem("user_type", userType);
                            if (typeof props.onNavigate === "function") {
                                props.onNavigate("upload_pg");
                            }
                        }
                        // No need to show success message if we navigated/logged in
                    } else {
                        setSuccess(res.data.message || 'Registration successful!');
                    }
                } catch {
                    setSuccess(res.data.message || 'Registration successful! Auto-login failed, please login.');
                }

                // Clear fields
                setFname('');
                setEmail('');
                setPassword('');
                setConfirmPassword('');
                setTimezoneVal('est');
                setError('');
                setAcceptedTerms(false); // reset T&C checkbox
            } else {
                setError(res.data.message || 'Registration failed.');
                setTooltip(res.data.tooltip || '');
                setSuccess('');
            }
        } catch (err) {
            setError(
                err.response?.data?.message ||
                'Registration failed. Please try again.'
            );
            setTooltip(err.response?.data?.tooltip || '');
            setSuccess('');
        }
        setLoading(false);
    };

    const handleFnameChange = (e) => {
        setFname(e.target.value);
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
    };

    const handleTimezoneToggle = (e) => {
        const enabled = e.target.checked;
        const val = enabled ? 'est' : 'local'; // checked = est, unchecked = local
        setTimezoneVal(val);
    };

    const handleTooltipClick = (e) => {
        // No-op, tooltip click is now tracked globally if needed
    };

    const handleAcceptedTermsChange = (e) => {
        setAcceptedTerms(e.target.checked);
    };

    // Common style for input fields
    const inputStyle = {
        width: "100%",
        padding: "12px 18px",
        borderRadius: 6,
        border: "1px solid #ccc",
        fontSize: "1rem",
        marginBottom: 16,
        boxSizing: "border-box",
        background: "#1E1E1E",
        color: "#e4e6e4" // <-- Updated to light gray for better readability
    };

    // Placeholder style for gray font
    const placeholderStyle = {
        color: "#888"
    };

    return (
        <div className="_44_user_register-container"
            style={{
                maxWidth: 420,
                margin: "0 auto",
                padding: "32px 24px",
                borderRadius: "16px",
                boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
                fontFamily: "'Outfit', sans-serif"
            }}
            data-analytics={MODULE_NAME}
        >
            <div style={{ display: "flex", alignItems: "center", marginBottom: "24px" }}>
                <a href="https://www.tontradingtools.com"  rel="noopener noreferrer">
                    <img
                        src="images/logo/logo.png"
                        alt="Logo"
                        style={{
                            height: "40px",
                            width: "auto",
                            objectFit: "contain",
                            borderRadius: "8px",
                            marginRight: "16px"
                        }}
                    />
                </a>
            </div>
            <h1 style={{
                textAlign: "center",
                fontWeight: 700,
                fontSize: "2.2rem",
                marginBottom: 8,
                color: "#1fa84f"
            }}>
                Free sign up 
            </h1>
            <p style={{
                textAlign: "center",
                fontSize: "1rem",
                color: "#5e5e5e",
                marginBottom: 18
            }}>
                Already have an account? <a href="https://pro.tontradingtools.com" style={{ color: "#1fa84f", textDecoration: "underline" }}>Login</a>
            </p>
            {tooltip && (
                <div style={{ color: "#888", marginBottom: 12, textAlign: "center" }}>
                    <span title={tooltip} onClick={handleTooltipClick} style={{ cursor: "pointer" }}>🛈 {tooltip}</span>
                </div>
            )}
            <form onSubmit={handleSubmit}>
                <input
                    id="fname"
                    type="text"
                    value={fname}
                    onChange={handleFnameChange}
                    autoComplete="given-name"
                    style={inputStyle}
                    placeholder="First Name"
                    required
                />
                <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={handleEmailChange}
                    autoComplete="username"
                    style={inputStyle}
                    placeholder="Email"
                    required
                />
                <input
                    id="password"
                    type="password"
                    value={password}
                    onChange={handlePasswordChange}
                    autoComplete="new-password"
                    style={inputStyle}
                    placeholder="Password"
                    required
                />
                <input
                    id="confirmPassword"
                    type="password"
                    value={confirmPassword}
                    onChange={handleConfirmPasswordChange}
                    autoComplete="new-password"
                    style={inputStyle}
                    placeholder="Confirm Password"
                    required
                />
   
                {/* Terms and Conditions acceptance */}
                <div style={{ marginBottom: 16, display: "flex", alignItems: "center", justifyContent: "flex-start", gap: 8 }}>
                    <label
                        style={{ display: "inline-flex", alignItems: "center", color: "#888", fontSize: 14 }}
                        title="Please confirm you have read and agree to the Terms and Conditions"
                    >
                        <input
                            id="accept-terms"
                            type="checkbox"
                            checked={acceptedTerms}
                            onChange={handleAcceptedTermsChange}
                            style={{ accentColor: "#1fa84f", marginRight: 8 }}
                            required
                        />
                        <span>
                            Kindly agree to the
                        </span>
                    </label>
                    <a
                        href="https://www.tontradingtools.com/terms-of-use.html"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#1fa84f", textDecoration: "underline", fontSize: 14 }}
                        title="View Terms and Conditions"
                    >
                        Terms and Conditions
                    </a>
                </div>
                {error && <div style={{ color: "#e63946", marginBottom: 12 }}>{error}</div>}
                {success && <div style={{ color: "#228B22", marginBottom: 12 }}>{success}</div>}
                <button
                    type="submit"
                    disabled={loading}
                    style={{
                        width: "100%",
                        padding: "12px 0",
                        background: "#1fa84f",
                        color: "#fff",
                        border: "none",
                        borderRadius: 6,
                        fontSize: "1.1rem",
                        cursor: loading ? "not-allowed" : "pointer",
                        fontWeight: "bold",
                        boxShadow: "0 2px 8px rgba(31,168,79,0.08)"
                    }}
                >
                    {loading ? "Registering..." : "Sign Up"}
                </button>
            </form>
        </div>
    );
};

export default _44_user_register;

